// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "prefixSumAddOffsetsComputeShader";
const shader = `struct Params {count : u32,};@group(0) @binding(0) var<storage,read_write> data : array<u32>;@group(0) @binding(1) var<storage,read> blockOffsets : array<u32>;@group(0) @binding(2) var<uniform> params : Params;@compute @workgroup_size(256,1,1)
fn main(@builtin(global_invocation_id) gid : vec3u,@builtin(workgroup_id) wid : vec3u) {let g=gid.x;if (g<params.count) {data[g]=data[g]+blockOffsets[wid.x];}}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}

/** @internal */
export const prefixSumAddOffsetsComputeShaderWGSL = { name, shader };
